$(document).ready(function() {
    $('[data-preview]').each(function() {
        var $this = $(this);
        var $img = $($this.attr('data-preview'));
        console.log($img.attr('src'));
        $this.on('change', function(e) {
            $img.attr('src', $this.val());
        });
    });
});